import React, { useEffect } from 'react';
import Hero from '../components/Hero';
import BriefSection from '../components/BriefSection';
import FeaturedProjects from '../components/FeaturedProjects';
import Services from '../components/Services';
import Contact from '../components/Contact';
import useScrollReveal from '../hooks/useScrollReveal';

const Home = ({ showToast }) => {
  useScrollReveal();

  // Auto-scroll to top on component mount
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const briefSections = [
  {
    heading: "Crafting Digital Experiences with Excellence",
    title: "About DashWeb Studio",
    content: [
      "At DashWeb Studio, we deliver full-stack web solutions tailored for startups, SMEs, and enterprises. From sleek frontends using React and Vue to robust backends with Node.js and Python, we build scalable and secure applications.",
      "Our workflow follows industry standards, incorporating CI/CD pipelines, automated testing, and cloud-native deployments to ensure your projects are delivered on time with top-notch quality.",
      "We prioritize clean design, seamless user experience, and maintainable code, turning your ideas into polished digital products that make an impact."
    ]
  },
];

  return (
    <main>
      <Hero />
      <FeaturedProjects />
      <Services />
      {briefSections.map((section, index) => (
        <BriefSection 
          key={index}
          heading={section.heading}
          title={section.title}
          content={section.content}
          className={section.className || ''}
        />
      ))}
      <Contact showToast={showToast} />
    </main>
  );
};

export default Home;